import React from 'react'
import { Switch } from 'react-router-dom'
import Loadable from './Loadable'
import { PrivateRoute, PublicRoute } from '../../../lib/routePermission'


const AsyncHome = Loadable({
    loader: () => import('../../events/components/pages/homeHistory')
})

const AsyncNotFound = Loadable({
    loader: () => import(/* webpackChunkName: "NotFound" */ 'Features/ui/components/NotFound')
})

const AsyncLoginO365 = Loadable({
    loader: () => import(/* webpackChunkName: "LoginO365" */ 'Features/auth/components/LoginO365')
})

const AsyncLoginBSRS = Loadable({
    loader: () => import('../../auth/components/LoginBSRS')
})

const AsyncAuthorizeO365 = Loadable({
    loader: () => import('../../auth/components/AuthorizeO365')
})

const AsyncEventDetail = Loadable({
    loader: () => import('../../events/components/pages/eventDetail')
})

const AsyncRoomsInEvent = Loadable({
    loader: () => import('../../events/components/pages/roomsInEvent')
})

const AsyncMyInformation = Loadable({
    loader: () => import(/* webpackChunkName: "Information" */ 'Features/user/components/Information')
})

const AsyncCreateOrder = Loadable({
    loader: () => import('../../order/components/pages/createOrder')
})

const AsyncSettings = Loadable({
    loader: () => import(/* webpackChunkName: "Settings" */ 'Features/ui/components/Settings')
})

const AsyncSettingsIntegrations = Loadable({
    loader: () => import(/* webpackChunkName: "SettingsIntegrations" */ 'Features/integration/components/SettingsIntegrations')
})

const AsyncGoogleCallback = Loadable({
    loader: () => import('../../user/components/pages/callBackGoogle')
})

const AsyncUserInfo = Loadable({
    loader: () => import('Features/user/components/UserInfo')
})

const AsyncUserInformation = Loadable({
    loader: () => import('../../user/components/pages/userInformation')
})

const AsyncEditUserInformation = Loadable({
    loader: () => import('../../user/components/pages/editUserInfomation')
})

// const AsyncUserChangePassword = Loadable({
//     loader: () => import('Features/user/components/UserChangePassword')
// })

const AsyncChangePassword = Loadable({
    loader: () => import('../../user/components/pages/changePassword')
})

const AsyncTerm = Loadable({
    loader: () => import('../../informations/components/pages/term')
})

const AsyncContact = Loadable({
    loader: () => import('../../informations/components/pages/contact')
})

const AsyncFaq = Loadable({
    loader: () => import('../../informations/components/pages/faq')
})

// const AsyncIntegrationInfo = Loadable({
//     loader: () => import('Features/user/components/IntegrationInfo')
// })

const AsyncViewEvent = Loadable({
    loader: () => import('../../amenityandservice/components/pages/OrderView')
})

const AsyncAmenityService = Loadable({
    loader: () => import('../../amenityandservice/components/pages/HouseKeeper')
})

const AsyncIntegrationInfo = Loadable({
    loader: () => import('../../user/components/pages/integrationInfo')
})

const AsyncIntegrationExchange = Loadable({
    loader: () => import('../../user/components/pages/integrationExchange')
})

const AsyncRooms = Loadable({
    loader: () => import('../../rooms/components/pages/rooms')
})

const AsyncHistory = Loadable({
    loader: () => import('../../events/components/pages/historyNew')
})

// const AsyncSearchRoom = Loadable({
//     loader: () => import('../../rooms/components/pages/searchRoom')
// })

const AsyncSuggestRoom = Loadable({
    loader: () => import('../../rooms/components/pages/suggestRoom')
})

const AsyncCreateEvent = Loadable({
    // oader: () => import('../../events/components/pages/createEvent')
    loader: () => import('../../events/components/pages/createEvent_new')
})

const AsyncUpdateEvent = Loadable({
    // loader: () => import('../../events/components/pages/updateEvent')
    loader: () => import('../../events/components/pages/updateEvent_new')
})

const AsyncEventSuccess = Loadable({
    loader: () => import('../../events/components/pages/eventSuccess')
})

const AsyncRoomInfo = Loadable({
    // loader: () => import('../../rooms/components/pages/roominfo')
    loader: () => import('../../rooms/components/pages/roominfoNew')

})

const AsyncMeetingRooms = Loadable({
    loader: () => import('../../rooms/components/pages/meetingRoom')
})

const AsyncMenu = Loadable({
    loader: () => import('./Menu')
})

const AsyncScanQR = Loadable({
    loader: () => import('./ScanQr')
})

const AsyncTest = Loadable({
    loader: () => import('./Test')
})

const AsyncAdvancedSearch = Loadable({
    loader: () => import('../../rooms/components/pages/advancedSearch')
})

const AsyncAdvancedSearchResult = Loadable({
    loader: () => import('../../rooms/components/pages/advancedSearchResult')
})

const AsyncHomeHistory = Loadable({
    loader: () => import('../../events/components/pages/homeHistory')
})

const AsyncRoomList = Loadable({
    loader: () => import('../../rooms/components/pages/roomList')
})

const AsyncMyReservation = Loadable({
    loader: () => import('../../events/components/pages/myReservation')
})

const AsyncHotdesk = Loadable({
    loader: () => import('../../hotdesk/components/pages/hotdesk')
})

const AsyncBuildingList = Loadable({
    loader: () => import('../../hotdesk/components/pages/buildingList')
})

const AsyncFloorList = Loadable({
    loader: () => import('../../hotdesk/components/pages/floorList')
})

const AsyncZoneList = Loadable({
    loader: () => import('../../hotdesk/components/pages/zoneList')
})

const AsyncCreateEventHotdesk = Loadable({
    loader: () => import('../../hotdesk/components/pages/createEventHotdesk')
})

const AsyncEventHotdeskSuccess = Loadable({
    loader: () => import('../../hotdesk/components/pages/eventHotdeskSuccess')
})

const AsyncHotdeskMyReservation = Loadable({
    loader: () => import('../../hotdesk/components/pages/hotdeskMyReservation')
})

const AsyncServiceDetail = Loadable({
    loader: () => import('../../order/components/pages/serviceOrder')
})

const AsyncServiceAllFacilities = Loadable({
    loader: () => import('../../order/components/pages/orderAllFacilities')
})

const AsyncServiceAllFoodAndBevs = Loadable({
    loader: () => import('../../order/components/pages/orderAllFoodAndBevs')
})

const AsyncServiceAllRequestList = Loadable({
    loader: () => import('../../order/components/pages/orderAllRequestList')
})

const AsyncServiceEditOrderFacility = Loadable({
    loader: () => import('../../order/components/pages/editOrderFacility')
})

const AsyncServiceEditOrderfoodAndBev = Loadable({
    loader: () => import('../../order/components/pages/editOrderFoodAndBev')
})

const AsyncConfirmResetPassword = Loadable({
    loader: () => import('../../auth/components/ConfirmResetPassword')
})

const AsyncMyQrCode = Loadable({
    loader: () => import('../../user/components/pages/myQrCode')
})

const AsyncScanQrCode = Loadable({
    loader: () => import('../../user/components/pages/scanQrCode')
})

export default () => (
    <Switch>
        <PrivateRoute exact path='/' component={AsyncHome} />
        <PublicRoute path='/login' component={AsyncLoginBSRS} />
        <PublicRoute path='/resetpassword/:key' component={AsyncConfirmResetPassword} />
        {/* <PublicRoute path='/aa' component={AsyncitemLocation} /> */}
        <PrivateRoute path='/logino365' component={AsyncLoginO365} />
        <PrivateRoute path='/myqrcode/:id' component={AsyncMyQrCode} />
        <PrivateRoute path='/scanqr' component={AsyncScanQrCode} />
        <PublicRoute path='/authorize' component={AsyncAuthorizeO365} />
        <PrivateRoute path='/google/authencallback' component={AsyncGoogleCallback} />
        <PrivateRoute path='/events/new/:date/:start/:endDate/:end/:roomsEmail' component={AsyncCreateEvent} />
        {/* <PrivateRoute path='/events/new/:roomsEmail' component={AsyncCreateEvent} /> */}
        <PrivateRoute path='/events/update/:typeEdit/:email/:eventId' component={AsyncUpdateEvent} />
        <PrivateRoute path='/events/success/:action/:eventId' component={AsyncEventSuccess} />
        <PrivateRoute path='/service/all/requestList' component={AsyncServiceAllRequestList} />
        <PrivateRoute path='/service/edit/facility/:id' component={AsyncServiceEditOrderFacility} />
        <PrivateRoute path='/service/edit/foodAndBev/:id' component={AsyncServiceEditOrderfoodAndBev} />
        <PrivateRoute path='/events/success/:action' component={AsyncEventSuccess} />
        <PrivateRoute path='/service/all/facilities' component={AsyncServiceAllFacilities} />
        <PrivateRoute path='/service/all/foodAndBevs' component={AsyncServiceAllFoodAndBevs} />
        <PrivateRoute path='/service/:email/:icaluid' component={AsyncServiceDetail} />
        <PrivateRoute path='/history/event/:email/:eventId' component={AsyncEventDetail} />
        <PrivateRoute path='/roomsorder/event/:email/:eventId' component={AsyncRoomsInEvent} />
        <PrivateRoute path='/events' component={AsyncMyReservation} />
        <PrivateRoute path='/scanQR' component={AsyncScanQR} />
        <PrivateRoute path='/info' component={AsyncMyInformation} />
        <PrivateRoute path='/order/create/:type/:roomEmail/:eventId/:iCalUId' component={AsyncCreateOrder} />
        <PrivateRoute path='/settings/integrations' component={AsyncSettingsIntegrations} />
        <PrivateRoute path='/settings' component={AsyncSettings} />
        <PrivateRoute path='/userinfo' component={AsyncUserInfo} />
        <PrivateRoute path='/userinformation' component={AsyncUserInformation} />
        <PublicRoute path='/changeInformation/:id' component={AsyncEditUserInformation} />
        <PrivateRoute path='/term' component={AsyncTerm} />
        <PrivateRoute path='/contact' component={AsyncContact} />
        <PrivateRoute path='/integration/exchange' component={AsyncIntegrationExchange} />
        <PrivateRoute path='/integration' component={AsyncIntegrationInfo} />
        <PrivateRoute path='/faq' component={AsyncFaq} />
        <PrivateRoute path='/changepassword/:id' component={AsyncChangePassword} />
        <PublicRoute path='/vieworder/:type/:id' component={AsyncViewEvent} />
        <PublicRoute path='/amenityservice' component={AsyncAmenityService} />
        <PrivateRoute path='/rooms' component={AsyncRooms} />
        <PrivateRoute path='/history' component={AsyncHistory} />
        <PrivateRoute path='/menu' component={AsyncMenu} />
        <PrivateRoute path='/roominfo/:email' component={AsyncRoomInfo} />
        <PrivateRoute path='/searchroom' component={AsyncAdvancedSearch} />
        <PrivateRoute path='/searchroomresult/:body' component={AsyncAdvancedSearchResult} />
        <PrivateRoute path='/roomlist' component={AsyncRoomList} />
        <PrivateRoute path='/meetingrooms' component={AsyncMeetingRooms} />
        <PrivateRoute path='/suggest' component={AsyncSuggestRoom} />
        <PrivateRoute path='/homehistory' component={AsyncHomeHistory} />
        <PrivateRoute path='/myreservation' component={AsyncMyReservation} />
        <PrivateRoute path='/hotdesk' component={AsyncHotdesk} />
        <PrivateRoute path='/building' component={AsyncBuildingList} />
        <PrivateRoute path='/floor/:buildingId' component={AsyncFloorList} />
        <PrivateRoute path='/zone/:buildingId/:floorId' component={AsyncZoneList} />
        <PrivateRoute path='/createeventhotdesk/:buildingId/:floorId/:zoneId' component={AsyncCreateEventHotdesk} />
        <PrivateRoute path='/eventhotdesksuccess/:eventId' component={AsyncEventHotdeskSuccess} />
        <PrivateRoute path='/hotdeskmyreservation' component={AsyncHotdeskMyReservation} />

        <PrivateRoute path='/test' component={AsyncTest} />

        <PrivateRoute component={AsyncNotFound} />
    </Switch>
)


// WEBPACK FOOTER //
// ./src/features/ui/components/Routes.js